




















































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { ActionTypes } from "@/data/enums";
import { ICompany } from "@/models/companies";
import { IAddress } from "@/models/addresses";
import ClientAddressesMixin from "@/mixins/clientAddressesMixin";
import ClientCompaniesMixin from "@/mixins/clientCompaniesMixin";
import { IClient } from "@/models/clients";

interface Form {
  company_id: ICompany["id"];
  address_id: IAddress["id"];
}

@Component
export default class CProdChangeCompanyOrAddress extends Mixins(
  ClientAddressesMixin,
  ClientCompaniesMixin
) {
  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ required: true })
  public value!: Form;

  // Lifecycle methods

  public created() {
    this.getClientAddresses({ clientId: this.clientId });
    this.getClientCompanies({ clientId: this.clientId });
  }

  public beforeDestroy() {
    this.binClientAddresses();
    this.binClientCompanies();
  }

  // Computed

  public get isLoading() {
    return this.isLoadingClientCompanies || this.isLoadingClientAddresses;
  }

  public get hasAddresses() {
    return this.clientAddresses?.length;
  }

  public get hasCompanies() {
    return this.clientCompanies?.length;
  }

  public get isCompany() {
    return !!this.form.company_id;
  }

  public get form(): Form {
    return this.value;
  }

  // Methods

  public onAddressSelect(addressId) {
    this.$emit("input", { address_id: addressId, company_id: null });
  }

  public onCompanySelect(companyId) {
    if (companyId === this.value.company_id) return;
    this.$emit("input", { address_id: null, company_id: companyId });
  }

  public refreshCompanies() {
    this.getClientCompanies({ clientId: this.clientId });
  }

  public refreshAddresses() {
    this.getClientAddresses({ clientId: this.clientId });
  }

  public refreshContract() {
    this.$emit("refresh-contract");
  }

  public openAddAddressModal() {
    return this.openAddressModal({
      clientId: this.clientId,
      actionType: ActionTypes.CREATE,
      config: {
        events: {
          success: () => {
            this.refreshAddresses();
          }
        }
      }
    });
  }

  public openAddCompanyModal() {
    this.openCompanyModal({
      clientId: this.clientId,
      actionType: ActionTypes.CREATE,
      config: {
        events: {
          success: () => {
            this.refreshCompanies();
          }
        }
      }
    });
  }
}
